const REDIRECT_URI_WHITELIST = [
  'https://dev.gcpshore.virginvoyages.com/',
  'https://cert.gcpshore.virginvoyages.com/',
  'https://stage.gcp.virginvoyages.com/',
  'https://application-integration.ship.virginvoyages.com/',
  'https://int.gcpshore.virginvoyages.com/',
  'https://www.virginvoyages.com/',
];

export default REDIRECT_URI_WHITELIST;
